import { render, staticRenderFns } from "./edit.vue.html?vue&type=template&id=52372ba1&scoped=true"
import script from "./edit.controller?vue&type=script&lang=js&external"
export * from "./edit.controller?vue&type=script&lang=js&external"
import style0 from "./edit.vue.html?vue&type=style&index=0&id=52372ba1&prod&lang=scss&scoped=true"
import style1 from "./edit.vue.html?vue&type=style&index=1&id=52372ba1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52372ba1",
  null
  
)

export default component.exports